import React from 'react';
import '../template-file-css/document-file-template.css';


export const GHP_InformedConsentforMedication = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_InformedConsentforMedication' className='file-pdf-document'>
            <div className='file-template'>

                <h3>This individual is</h3>
                <p>
                    <input type="checkbox" id="cbIndividual_1" name="cbIndividual_1" className='add-only' value="1" /> An adult without court-appointed guardian of the person. (Continue immediately below, using <strong>A. CAPACITY</strong>)
                </p>
                <p>
                    <input type="checkbox" id="cbIndividual_2" name="cbIndividual_2" className='add-only' value="1" /> A minor or adult with court appointed guardian of the person, and consent can be obtained from the parent or legal custodian of a minor or the guardian of an adult. (Continue below, using <strong>B. INFORMED CONSENT TO PSYCHOTROPIC MEDICATION</strong>).
                </p>
                <h3>A. Capacity </h3>
                <p>
                    I <input type="text" placeholder='(Physician name)' id="txtPhysicianName" name="txtPhysicianName" className='add-only w-250' /> have  examined <input type="text" id="txtHaveExamined" name="txtHaveExamined" className='add-only w-250' /> to determine whether this person has the capacity to understand and appreciate the nature and consequences  of  his/her  actions,  including  the  likelihood  of  therapeutic  benefit  of  medication  and the risk of side effects and possible treatment alternatives, and I find that he/she:
                </p>
                <p>
                    <input type="checkbox" id="cbWillingConsent" name="cbWillingConsent" className='add-only' value="1" /> Does have mental and physical capacity and is willing to consent. (Continue below with <strong>B. INFORMED CONSENT TO PSYCHOTROPIC MEDICATION)</strong>
                </p>
                <p>
                    <input type="checkbox" id="cbUnWillingConsent" name="cbUnWillingConsent" className='add-only' value="1" /> Does have mental and physical capacity and is unwilling to consent but is not unsafe.  (Comply with individual's right to decline medication.)
                </p>
                <p>
                    <span className='eleHeader'>Reasons (if not already documented in the individual's record)</span>
                    <textarea id="txtReasons" name="txtReasons" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-450 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Physician's signature</td>
                        <td className='small'>Date</td>
                        <td className='small'>Time</td>
                    </tr>
                    <tr>
                        <td className='w-750 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Physician's printed name</td>
                    </tr>
                </table>
                <h3>B. Informed Consent to Psychotropic Medication</h3>
                <p>
                    <strong>Names of Medication(s)</strong>
                    to which the individual is consenting on this date:
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>1.</span>
                            <input type="text" id="txtNameOfMedication_1" name="txtNameOfMedication_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>2.</span>
                            <input type="text" id="txtNameOfMedication_2" name="txtNameOfMedication_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>3.</span>
                            <input type="text" id="txtNameOfMedication_3" name="txtNameOfMedication_3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>4.</span>
                            <input type="text" id="txtNameOfMedication_4" name="txtNameOfMedication_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>5.</span>
                            <input type="text" id="txtNameOfMedication_5" name="txtNameOfMedication_5" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>6.</span>
                            <input type="text" id="txtNameOfMedication_6" name="txtNameOfMedication_6" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    In general terms, I have discussed the above medication(s) with the individual /parent/legal custodian/guardian. Expected results, common side effects, and possible risks were discussed and presented in a clear and reasonable manner consistent with his/her abilities of comprehension and understanding.  Alternate treatments (including no treatment and its consequences) were also discussed. I also informed this person that he/she could refuse DBHDD Policy #03-534Attachment A – Version 12-14-2011  2 of 2medication and/or could withdraw consent.  I informed him/her that if such refusal would be unsafe to the individual or others, the individual may be medicated involuntarily. I have informed this person of his/her right to file a human rights complaint or to seek judicial protection ofhis/her rights or privileges by law.
                </p>
                <table>
                    <tr>
                        <td className='w-450 signature'>&nbsp;</td>
                        <td className='w-150 signature'>&nbsp;</td>
                        <td className='w-150 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Physician signature</td>
                        <td className='small'>Date</td>
                        <td className='small'>Time</td>
                    </tr>
                    <tr>
                        <td className='w-750 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Physician's printed name</td>
                    </tr>
                </table>
                <h4>Written Consent</h4>
                <p>
                    The above-named physician explained the benefit(s) and the effects of the above medication(s).
                </p>
                <p>
                    I understand and consent to this medication as ordered by the physician and agree to report any changes in my (or the individual's) condition.  I also understand that I may refuse to take medication when it is offered and/or revoke consent at any time.  I understand that if such refusal would be unsafe to the individual or others, medication may be given involuntarily. I understand I have the right to file a human rights complaint or to seek judicial protection of myrights or privileges as provided by law.
                </p>
                <table>
                    <tr>
                        <td className='w-450 signature'>&nbsp;</td>
                        <td className='w-150 signature'>&nbsp;</td>
                        <td className='w-150 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Individual/Parent/Legal custodian/Guardian signature</td>
                        <td className='small'>Date</td>
                        <td className='small'>Time</td>
                    </tr>
                </table>
                <h4>Oral Consent</h4>
                <p>
                    If by anyone other than individual, written consent must be obtained subsequently:
                </p>
                <table>
                    <tr>
                        <td className='w-450 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                        <td className='w-150 signature' >&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Physician signature</td>
                        <td className='small'>Date</td>
                        <td className='small'>Time</td>
                    </tr>
                    <tr>
                        <td className='w-450 signature'>&nbsp;</td>
                        <td className='w-150 signature'>&nbsp;</td>
                        <td className='w-150 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Staff/Witness/Title</td>
                        <td className='small'>Date</td>
                        <td className='small'>Time</td>
                    </tr>
                </table>
                <h4>I Revoke my Consent</h4>
                <table>
                    <tr>
                        <td className='w-450 signature'>&nbsp;</td>
                        <td className='w-150 signature'>&nbsp;</td>
                        <td className='w-150 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Individual/Parent/Legal Custodian/Guardian</td>
                        <td className='small'>Date</td>
                        <td className='small'>Time</td>
                    </tr>
                    <tr>
                        <td className='w-450 signature'>&nbsp;</td>
                        <td className='w-150 signature'>&nbsp;</td>
                        <td className='w-150 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small'>Staff Witness</td>
                        <td className='small'>Date</td>
                        <td className='small'>Time</td>
                    </tr>
                </table>


            </div>
        </form >
    )
}